var _path, _path2, _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _ellipse2, _ellipse3, _path3, _path4, _circle6, _circle7, _circle8, _path5, _path6, _rect, _path7, _path8, _path9, _path0, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa9a32cc-44b8-4cc2-a997-023e29387d3e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 738.21997,
    height: 400.90166,
    viewBox: "0 0 738.21997 400.90166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.2,638.20907V570.32082h-22v67.88825a13.98286,13.98286,0,0,0-7,12.11175h36A13.98286,13.98286,0,0,0,527.2,638.20907Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#1c2144"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M586.2,638.20907V570.32082h-22v67.88825a13.98286,13.98286,0,0,0-7,12.11175h36A13.98286,13.98286,0,0,0,586.2,638.20907Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#1c2144"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314.33362,
    cy: 238.54887,
    r: 145.45113,
    fill: "#1c2144"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.33362,
    cy: 311.43609,
    rx: 57.63158,
    ry: 19.21053,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.19076,
    cy: 205.61654,
    r: 24.69925,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.47648,
    cy: 205.61654,
    r: 24.69925,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.67948,
    cy: 205.31579,
    r: 19.21053,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.73212,
    cy: 205.31579,
    r: 19.21053,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.33362,
    cy: 87.09774,
    rx: 96.05263,
    ry: 74.09774,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.33362,
    cy: 18,
    rx: 38,
    ry: 18,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M546.28429,509.30433c6.323-6.40629,16.04713-6.53419,24.2561-4.42458,9.786,2.51489,18.116,8.57423,27.17791,12.79851a49.55555,49.55555,0,0,0,14.58024,4.54776,38.27945,38.27945,0,0,0,36.63871-17.0858,38.7584,38.7584,0,0,0,4.54212-30.91717,1.50128,1.50128,0,0,0-2.89283.79752,35.70693,35.70693,0,0,1-3.34417,27.11259,35.29669,35.29669,0,0,1-35.30417,17.03843,49.62651,49.62651,0,0,1-14.22886-4.81212c-8.76148-4.28973-16.98465-10.00419-26.54935-12.41745-9.21411-2.32481-19.9481-1.90083-26.997,5.241-1.35753,1.37543.76245,3.4981,2.12132,2.12132Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.28429,507.183c-6.22928-6.31139-15.3898-7.36984-23.77027-5.92682-9.6154,1.65567-17.88675,6.88869-26.379,11.36988-8.6772,4.57879-17.92825,8.08187-27.8912,6.48578a35.20905,35.20905,0,0,1-23.1751-14.039,35.77653,35.77653,0,0,1-5.208-30.05228,1.50128,1.50128,0,0,0-2.89283-.79752,38.80889,38.80889,0,0,0,2.82291,27.89016A37.47231,37.47231,0,0,0,460.76945,520.297c9.41409,3.348,19.35061,2.63,28.52089-1.11613,9.42621-3.85066,17.77515-10.13661,27.45644-13.36827,8.93708-2.98324,20.2603-3.75844,27.41619,3.49176,1.3583,1.37619,3.47944-.7453,2.12132-2.12132Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.36371,
    cy: 258.5,
    r: 11,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.31,
    cy: 198.77165,
    r: 4,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.31,
    cy: 198.77165,
    r: 4,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.24474,605.2446a158.39392,158.39392,0,0,0,7.399,43.78516c.10309.32895.21112.653.31912.98195h27.61247c-.02946-.2946-.05895-.62355-.08841-.98195-1.84115-21.166-12.456-149.988.23569-172.01807C320.613,478.79885,284.10409,537.99081,286.24474,605.2446Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.31664,649.02976c.23077.32895.47134.65789.71683.98195h20.71424c-.15711-.27986-.33877-.6088-.54989-.98195-3.42211-6.17647-13.5509-24.642-22.95308-43.78516-10.10428-20.57187-19.37389-41.92437-18.59323-49.65231C267.41094,557.33524,260.41946,610.46856,288.31664,649.02976Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 398.90166,
    width: 738.21997,
    height: 2,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M914.2,649.32082l-58-38.68109V311.32082a2,2,0,0,0-2-2h-3a2,2,0,0,0-2,2V609.31411L789.2124,649.32082l7.67066-.09845,52.317-35.0877v35.18615h7V615.46767l50.32941,33.7547Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M751.2002,340.3208a2.00229,2.00229,0,0,0-2,2V522.32129a2.0026,2.0026,0,0,0,2,2h203a2.00261,2.00261,0,0,0,2-2V342.3208a2.0023,2.0023,0,0,0-2-2Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M841.37091,338.32082a3.00619,3.00619,0,0,0,2.8291,2h18a3.00618,3.00618,0,0,0,2.8291-2Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M800.37091,526.32082h105.6582a3.0062,3.0062,0,0,0-2.8291-2h-100A3.00621,3.00621,0,0,0,800.37091,526.32082Z",
    transform: "translate(-230.89001 -249.54917)",
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.44038,
    cy: 154.56725,
    r: 27.83481,
    fill: "#1c2144",
    opacity: 0.3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 638.23489,
    cy: 185.28709,
    r: 27.83481,
    fill: "#1c2144",
    opacity: 0.3
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.50169,
    cy: 186.65898,
    r: 40.08213,
    fill: "#1c2144",
    opacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.35651,
    cy: 201.21889,
    r: 40.08213,
    fill: "#1c2144",
    opacity: 0.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.92477,
    cy: 212.94887,
    r: 40.08213,
    fill: "#1c2144",
    opacity: 0.3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.27039,
    cy: 155.14007,
    r: 40.08213,
    fill: "#1c2144",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeImage);
export default __webpack_public_path__ + "static/media/welcomeImage.028710e769f0b7044451b13e4f3fb798.svg";
export { ForwardRef as ReactComponent };